import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  TextField,
  Typography,
  Stack,
  Grid,
  Box
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { UploadSingleFile } from './upload';

function ConfirmationDialog(props) {
  const {
    open,
    handleClose,
    onAgree,
    dialogContent,
    titleContent,
    agreeText,
    disagreeText,
    title,
    customerDetailsImage,
    setCustomerDetailsImage,
    customerDetails,
    setCustomerDetails
  } = props;

  const handleDrop = (acceptedFiles, fileName) => {
    const file = acceptedFiles[0];
    if (file) {
      const filePath = file.name.split('.').pop();
      const name = `${fileName}.${filePath}`;
      const newFile = new File([file], name, { type: file.type });
      setCustomerDetailsImage({
        ...customerDetailsImage,
        [fileName]: { file: { ...newFile, preview: URL.createObjectURL(newFile) }, uploadFile: newFile }
      });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{titleContent}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{dialogContent}</DialogContentText>
        {title === 'SOLD' && (
          <>
            <Typography my={1} sx={{ fontSize: 16, fontWeight: 'bold', color: 'black' }}>
              Customer Details
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ my: 1 }}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{ width: '100%' }}>
                <TextField
                  fullWidth
                  // type="number"
                  label="Name"
                  name="name"
                  value={customerDetails.name}
                  onChange={(event, value) => {
                    setCustomerDetails((prev) => ({
                      ...prev,
                      name: event.target.value
                    }));
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{ width: '100%' }}>
                <TextField
                  fullWidth
                  type="number"
                  label="Mobile No."
                  name="phoneNumber"
                  value={customerDetails.phoneNumber}
                  onChange={(event, value) => {
                    setCustomerDetails((prev) => ({
                      ...prev,
                      phoneNumber: event.target.value
                    }));
                  }}
                />
              </Grid>
            </Stack>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <TextField
                fullWidth
                sx={{ my: 1 }}
                // type="number"
                label="Address"
                name="address"
                value={customerDetails.address}
                onChange={(event, value) => {
                  setCustomerDetails((prev) => ({
                    ...prev,
                    address: event.target.value
                  }));
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <TextField
                fullWidth
                sx={{ my: 1 }}
                // type="number"
                label="Pan/aadhar number"
                name="aadharPanNumber"
                value={customerDetails.aadharPanNumber}
                onChange={(event, value) => {
                  setCustomerDetails((prev) => ({
                    ...prev,
                    aadharPanNumber: event.target.value
                  }));
                }}
              />
            </Grid>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ my: 1 }}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{ width: '100%' }}>
                <DatePicker
                  label="Delivery Date"
                  fullWidth
                  value={customerDetails.deliveryDate}
                  inputFormat="dd/MM/yyyy"
                  onChange={(value) => {
                    setCustomerDetails((prev) => ({
                      ...prev,
                      deliveryDate: value
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      sx={{
                        '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'unset'
                        },
                        '& .MuiFormHelperText-root.Mui-error': {
                          display: 'none'
                        }
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{ width: '100%' }}>
                <TextField
                  fullWidth
                  type="number"
                  label="Sold Price"
                  name="soldPrice"
                  value={customerDetails.soldPrice}
                  onChange={(event, value) => {
                    setCustomerDetails((prev) => ({
                      ...prev,
                      soldPrice: event.target.value
                    }));
                  }}
                />
              </Grid>
            </Stack>
            <Box my={1}>
              <Typography sx={{ fontSize: '16px', textAlign: 'center' }}>Pan/aadhar Image</Typography>
              <UploadSingleFile
                maxSize={3145728}
                accept="image/*"
                sx={{ width: '100%' }}
                file={customerDetailsImage?.profile?.file}
                onDrop={(accFile) => handleDrop(accFile, 'profile')}
                // borderColor={_.isEmpty(docs?.frontView?.file) ? 'red' : undefined}
              />
            </Box>
            <Typography my={1} sx={{ fontSize: 16, fontWeight: 'bold', color: 'black' }}>
              Sales Executive Details
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ my: 1 }}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{ width: '100%' }}>
                <TextField
                  fullWidth
                  // type="number"
                  label="Name"
                  name="sellerName"
                  value={customerDetails.sellerName}
                  onChange={(event, value) => {
                    setCustomerDetails((prev) => ({
                      ...prev,
                      sellerName: event.target.value
                    }));
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{ width: '100%' }}>
                <TextField
                  fullWidth
                  type="number"
                  label="Mobile No."
                  name="sellerPhoneNumber"
                  value={customerDetails.sellerPhoneNumber}
                  onChange={(event, value) => {
                    setCustomerDetails((prev) => ({
                      ...prev,
                      sellerPhoneNumber: event.target.value
                    }));
                  }}
                />
              </Grid>
            </Stack>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          {disagreeText}
        </Button>
        <Button onClick={onAgree} color="primary" autoFocus>
          {agreeText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onAgree: PropTypes.func,
  dialogContent: PropTypes.string,
  titleContent: PropTypes.string,
  agreeText: PropTypes.string,
  disagreeText: PropTypes.string
};

export default ConfirmationDialog;
